import type { SVGProps } from 'react';
import * as React from 'react';

/* AUTOGENERATED: DO NOT EDIT */
import _styles from '../logo.module.css';
export const MicrosoftIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" {...props}>
    <path fill="#F35325" d="M1 1h8.57v8.57H1z" />
    <path fill="#81BC06" d="M10.43 1H19v8.57h-8.57z" />
    <path fill="#05A6F0" d="M1 10.43h8.57V19H1z" />
    <path fill="#FFBA08" d="M10.43 10.43H19V19h-8.57z" />
  </svg>
);
